import { InlineBanner } from "components/ui/inline-banner";
import { InteractiveTextLink } from "components/ui/interactive-text-link";
import React from "react";
import { WizardStepProps } from "./wizard-types";
import { WorkflowSummaryCard } from "./workflow-summary-card";

export const WizardReview: React.FC<WizardStepProps> = props => {
    const {
        workflow,
        workflowSettings,
        isDraft,
        editable,
        publishBlocker,
        onShowActions,
    } = props;

    return (
        <div className="space-y-5">
            <div>
                <h3 className="font-medium text-gray-900">
                    {isDraft ? "Review & publish" : "Review"}
                </h3>
                <p className="text-sm text-gray-500">
                    {isDraft
                        ? "Here's what will happen once you publish this workflow."
                        : "Here's what this workflow does."}
                </p>
            </div>
            <WorkflowSummaryCard
                workflow={workflow}
                workflowSettings={workflowSettings}
            />
            {isDraft ? (
                editable && publishBlocker ? (
                    <InlineBanner type="warning">
                        This workflow is not ready to publish yet. {publishBlocker}{" "}
                        <InteractiveTextLink onClick={onShowActions}>
                            Go to the Actions page
                        </InteractiveTextLink>
                    </InlineBanner>
                ) : (
                    <InlineBanner type="info">
                        This workflow is a draft and will not run until you publish it.
                        Publish it below when everything looks right, or save it as a
                        draft and finish later.
                    </InlineBanner>
                )
            ) : (
                <InlineBanner type="success">
                    This workflow is published and runs whenever its trigger is met.
                </InlineBanner>
            )}
        </div>
    );
};
